/* eslint-disable @typescript-eslint/no-explicit-any */

import React from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";
import { Icon, IconSize } from "@gaming/xds-react-js";
import { ApplicationLaunch } from "@gaming/xds-react-js-icons";

import { ContentBox, ContentBoxIcon } from "../ContentBox";
import { TextLink } from "../TextLink";
import * as styles from "./InfoBoxBase.module.css";

export const addBoldTags = (text: string) => `<b>${text}</b>`;

export type InfoBoxBaseProps = Readonly<{
  title: string;
  icon: ContentBoxIcon;
  rightSideText?: string;
  mainText?: string | JSX.Element | JSX.Element[];
  actionRequiredText?: string;
  actionLink?: string;
}>;

export const InfoBoxBase = ({
  title,
  icon,
  rightSideText = "",
  mainText = "",
  actionRequiredText = "",
  actionLink = "",
}: InfoBoxBaseProps) => (
  <ContentBox
    titleConfiguration={{
      title,
      icon,
      disabled: true,
      separatorBar: !!mainText || !!actionRequiredText,
      rightSideText,
    }}
  >
    <Row className={styles.containerRow}>
      <Column className={styles.subtitleColumn}>
        <p>{mainText}</p>
      </Column>
      {actionRequiredText && actionLink && (
        <Column>
          <div className={styles.actionRequired}>
            <TextLink href={actionLink} className={styles.actionRequiredLink}>
              {actionRequiredText}
            </TextLink>
            <Icon icon={ApplicationLaunch} iconSize={IconSize.Custom} />
          </div>
        </Column>
      )}
    </Row>
  </ContentBox>
);
